<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <GoodsTabLinks />

                    <GoodsUpsertForm
                        class="mt-4"
                        :entity="entity"
                        @deleted="$router.push(`/grocers/${$route.params.id}/goods`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js'

    import GoodsTabLinks from '@/components/grocers/GoodsTabLinks'
    import GoodsUpsertForm from '@/components/grocers/GoodsUpsertForm'

    export default {
        components: {
            GoodsTabLinks,
            GoodsUpsertForm,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch()
        },

        methods: {
            async fetch() {
                const { id, goods_id } = this.$route.params

                const [error, result] = await to(this.axios.get(`/grocers/${id}/goods/${goods_id}`))
                this.entity = result.data

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении товара. ' + error);
                }
            }
        }
    }
</script>
